import { createMuiTheme } from '@material-ui/core/styles'

export const SliderTheme = (severity) => {
  let gradient = ''
  let thumb = ''
  let thumbColor = ''

  if (severity > 0 && severity <= 20) {
    gradient = 'linear-gradient(to right, rgba(82,145,252,1) 50%, rgba(82,145,252,1) 50%)'

    thumb = 'rgba(82,145,252,1)'
    thumbColor = '#fff'
  } else if (severity > 20 && severity <= 40) {
    const severityPercent = (severity - 20) * 5
    const range = (-(3 / 7) * severityPercent) + 92.85

    gradient = `
      linear-gradient(to right, 
        rgba(82,145,252,1) 0% ${range}%, 
        rgba(78,23,154,1) ${range}%)
    `

    thumb = 'rgba(78,23,154,1)'
    thumbColor = '#fff'
  } else if (severity > 40 && severity <= 60) {
    const severityPercent = (severity - 40) * 5
    let range = 0
    if (severityPercent >= 50) {
      range = (-(0.125) * severityPercent) + 46.25
    } else {
      range = (-(0.275) * severityPercent) + 52.75
    }

    gradient = `
      linear-gradient(to right, 
        rgba(82,145,252,1) 0% ${range}%, 
        rgba(78,23,154,1) ${range}% ${range * 2}%, 
        rgba(245,216,24,1) ${range * 2}%)
    `

    thumb = 'rgba(245,216,24,1)'
    thumbColor = '#414342'
  } else if (severity > 60 && severity <= 80) {
    const severityPercent = (severity - 60) * 5
    let range = 0
    if (severityPercent >= 50) {
      range = (-0.0625 * severityPercent) + 31.625
    } else {
      range = (-0.1125 * severityPercent) + 33.875
    }

    gradient = `
      linear-gradient(to right, 
        rgba(82,145,252,1) 0% ${range}%, 
        rgba(78,23,154,1) ${range}% ${range * 2}%, 
        rgba(245,216,24,1) ${range * 2}% ${range * 3}%, 
        rgba(231,132,15,1) ${range * 3}%)
    `

    thumb = 'rgba(231,132,15,1)'
    thumbColor = '#fff'
  } else {
    const severityPercent = (severity - 80) * 5
    let range = 0
    if (severityPercent >= 0 && severityPercent < 33.3) {
      range = (-0.0625 * severityPercent) + 25
    } else if (severityPercent >= 33.3 && severityPercent < 66.6) {
      // range = (-0.05833 * severityPercent) + 25.04167
      range = (-0.05 * severityPercent) + 24.75
    } else {
      range = (-0.05 * severityPercent) + 25
    }

    gradient = `
      linear-gradient(to right, 
        rgba(82,145,252,1) 0% ${range}%, 
        rgba(78,23,154,1) ${range}% ${range * 2}%, 
        rgba(245,216,24,1) ${range * 2}% ${range * 3}%, 
        rgba(231,132,15,1) ${range * 3}% ${range * 4}%,
        rgba(211,17,17,1) ${range * 4}%)
    `

    thumb = 'rgba(211,17,17,1)'
    thumbColor = '#fff'
  }

  return createMuiTheme({
    overrides: {
      MuiSlider: {
        track: {
          backgroundImage: gradient
        },
        thumb: {
          backgroundColor: thumb
        }
      },
      PrivateValueLabel: {
        circle: {
          backgroundColor: thumb
        },
        label: {
          color: thumbColor,
          fontWeight: 600
        }
      }
    }
  })
}
